"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __importStar(require("lodash"));
var Joins_1 = __importDefault(require("./Joins"));
var JoinTree_1 = require("./JoinTree");
var JoinOperator_1 = __importDefault(require("./interfaces/JoinOperator"));
var JoinType_1 = __importDefault(require("./interfaces/JoinType"));
var FunctionName_1 = __importDefault(require("./interfaces/FunctionName"));
var ResultColumnType_1 = __importDefault(require("./interfaces/ResultColumnType"));
var DataType_1 = __importDefault(require("./interfaces/DataType"));
var AbstractQueryFactory = /** @class */ (function () {
    function AbstractQueryFactory() {
    }
    AbstractQueryFactory.getTablesFromFilters = function (jsonLogic) {
        var m;
        var tables = [];
        var regex = /\"field\"\s*?:\s*?\"(.*?)\.(.*?)"/gm;
        while ((m = regex.exec(jsonLogic)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            // The result can be accessed through the `m`-variable.
            m.forEach(function (match, groupIndex) {
                if (groupIndex === 1) {
                    tables.push(match);
                }
            });
        }
        return tables;
    };
    AbstractQueryFactory.getResultColumn = function (tableName, column) {
        var col = {
            alias: AbstractQueryFactory.createAlias(tableName, column.name),
            name: column.name,
            table: tableName,
            dataType: column.dataType,
            type: ResultColumnType_1.default.COLUMN,
        };
        if (column.type === "dimension") {
            return col;
        }
        if (column.type === "metric") {
            var func = {
                alias: AbstractQueryFactory.createAlias(tableName, column.name),
                column: col,
                name: FunctionName_1.default.SUM,
                defaultFunc: FunctionName_1.default.SUM,
                type: ResultColumnType_1.default.FUNC,
                dataType: DataType_1.default.NUMBER,
            };
            return func;
        }
    };
    AbstractQueryFactory.getResultColumnForJoin = function (tableName, columnName) {
        var col = {
            alias: "",
            name: columnName,
            table: tableName,
            dataType: DataType_1.default.STRING,
            type: ResultColumnType_1.default.COLUMN,
        };
        return col;
    };
    AbstractQueryFactory.addResultColumnToAq = function (aq, resultColumn, metadataJoins) {
        var newAq = __assign({}, aq);
        newAq.columns.push(resultColumn);
        return AbstractQueryFactory.applyJoinsOnAq(newAq, metadataJoins);
    };
    AbstractQueryFactory.applyJoinsOnAq = function (aq, metadataJoins) {
        var newAq = __assign({}, aq);
        newAq.joins = AbstractQueryFactory.getJoins(newAq, metadataJoins);
        newAq.notJoined = false;
        return newAq;
    };
    AbstractQueryFactory.getJoins = function (abstractQuery, metadataJoins) {
        var _a;
        var resultColumntables = AbstractQueryFactory.getTablesFromResultColumns(abstractQuery.columns);
        var filterTables = AbstractQueryFactory.getTablesFromFilters((_a = abstractQuery.filters) === null || _a === void 0 ? void 0 : _a.jsonLogic);
        var tables = __spreadArray(__spreadArray([], resultColumntables), filterTables);
        if (tables.length <= 1) {
            return [];
        }
        var joinTree = new JoinTree_1.JoinTree(metadataJoins).generate();
        var joins = new Joins_1.default(joinTree).getJoins(tables);
        return joins.map(function (join) {
            return AbstractQueryFactory.generateJoinObject(join, metadataJoins);
        });
    };
    AbstractQueryFactory.generateJoinObject = function (join, metadataJoins) {
        var metadataJoin = _.find(metadataJoins, function (x) {
            return AbstractQueryFactory.comapreMetadataJoin(join, x);
        });
        var newJoin = {
            from: AbstractQueryFactory.getResultColumnForJoin(metadataJoin.pkTable, metadataJoin.pkColumn),
            to: AbstractQueryFactory.getResultColumnForJoin(metadataJoin.fkTable, metadataJoin.fkColumn),
            type: JoinType_1.default.INNER,
            conditionOperator: JoinOperator_1.default.EQUALS,
        };
        return newJoin;
    };
    AbstractQueryFactory.comapreMetadataJoin = function (join, metadataJoin) {
        if (metadataJoin.pkTable === join.to &&
            metadataJoin.fkTable === join.from) {
            return true;
        }
        if (metadataJoin.pkTable === join.from &&
            metadataJoin.fkTable === join.to) {
            return true;
        }
        return false;
    };
    AbstractQueryFactory.getTablesFromResultColumns = function (rcs) {
        return _.uniq(_.flatten(rcs.map(function (rc) {
            if (rc.type == ResultColumnType_1.default.COLUMN) {
                var col = rc;
                return [col.table];
            }
            if (rc.type == ResultColumnType_1.default.FUNC) {
                var func = rc;
                return [func.column.table];
            }
            return [];
        })));
    };
    AbstractQueryFactory.createAlias = function (tableName, columnName) {
        return tableName + "_" + columnName + "_" + AbstractQueryFactory.makeRandString();
    };
    AbstractQueryFactory.makeRandString = function () {
        var result = "";
        var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var charactersLength = characters.length;
        var length = 5;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    };
    return AbstractQueryFactory;
}());
exports.default = AbstractQueryFactory;
//# sourceMappingURL=AbstractQueryFactory.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/abstract_query/AbstractQueryFactory.js
// module id = 1575
// module chunks = 8